import { BorderBeam } from "border-beam"
import { IconAtom2Outline18 } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"

interface TranslationOverlayProps {
	languageName: string
	// Positioning override. Defaults to covering the whole parent (inset-0);
	// pass e.g. "top-12" to leave a header interactive.
	className?: string
}

// Covers the editing pane while a background translation runs, blocking
// interaction. Rendered as a pane-level absolute layer (not inside the scroll
// container) so it stays put when the article is scrolled.
export function TranslationOverlay({
	languageName,
	className,
}: TranslationOverlayProps) {
	return (
		<div
			className={cn(
				"absolute inset-0 z-30 flex items-center justify-center bg-white/60 backdrop-blur-[2px] dark:bg-gray-900/60",
				className,
			)}
		>
			<BorderBeam
				size="line"
				colorVariant="colorful"
				duration={2.4}
				strength={0.7}
				className="relative rounded-xl ring-1 ring-black/10 dark:ring-white/15"
			>
				<div className="flex items-center gap-2.5 rounded-xl bg-white px-4 py-3 text-sm font-medium text-secondary shadow-sm dark:bg-gray-850">
					<IconAtom2Outline18
						className="h-4 w-4"
						style={{ color: "var(--green-500)" }}
					/>
					Translating into {languageName}...
				</div>
			</BorderBeam>
		</div>
	)
}
